import React from 'react';
import { Typography } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';

import CustomToolbar from '../../common/CustomToolbar/CustomToolbar';

export const tableSettings = options => {
  const eventHandlers = options.eventHandlers;
  const locale = eventHandlers.locale;

  return {
    name: <Typography variant="h3">{locale.getMsg(`tableNameHeader${options.reasonType}`)}</Typography>,
    columns: [
      {
        name: 'id',
        label: 'Id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'name',
        label: locale.getMsg('reasonNameTableHeader'),
      },
      {
        name: 'isActive',
        label: locale.getMsg('reasonActiveTableHeader'),
        options: {
          sort: false,
          setCellProps: () => ({
            className: 'no-padding-cell',
            style: { width: '400px' },
          }),
          customBodyRender: (value, tableMeta) => {
            const id = tableMeta.rowData[0];
            return (
              <Switch
                checked={value}
                onChange={e => {
                  eventHandlers.updateReasonStatus(id, e.target.checked);
                }}
                color="primary"
                name="checkedB"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            );
          },
        },
      },
    ],
    options: {
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 10, 20, 50, 100],
      rowsPerPage: options.pageSize,
      print: true,
      search: true,
      filter: false,
      serverSide: true,
      count: options.count,
      page: options.page,
      customToolbar: () => (
        <CustomToolbar eventHandlers={eventHandlers} isTableDataLoading={options.isTableDataLoading} />
      ),
      onTableChange: (action, tableState) => {
        if (action === 'changePage' || action === 'changeRowsPerPage') {
          eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
        }
      },
    },
  };
};
